import { render, staticRenderFns } from "./BaseGrid.vue?vue&type=template&id=5b3120a4&scoped=true&"
import script from "./BaseGrid.vue?vue&type=script&lang=js&"
export * from "./BaseGrid.vue?vue&type=script&lang=js&"
import style0 from "./BaseGrid.vue?vue&type=style&index=0&id=5b3120a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3120a4",
  null
  
)

export default component.exports